let actionimgRequestUrl = 'http://www.chenniao.com:8080/api/Upload/UploadImg'; //请求服务器接口地址,
let actionRequestUrl = 'http://www.chenniao.com:8080/api/Upload/UploadFile'; //请求服务器接口地址,
let imgip = 'http://www.chenniao.com:8081/'
function getImgUrl(icon) {
    return this.imgip + icon
  }
export default {
    actionimgRequestUrl,
    actionRequestUrl,
    getImgUrl,
    imgip
}